import React, { useEffect, useRef, useState } from 'react'
import { getApi, postApi, putApi } from '../../../Services/apiService'
import { resetFormData } from '../../../Utils/helper';
import { toast } from 'react-toastify';
import { clearIdsStatus } from '../../../Counter/createGroup';
import { useDispatch } from 'react-redux';

function EditProductGroup({ setMethodType, setFormData, setError, productToEdit, formDataCopy, type, fetchData, setIsLoading, setShowAddProductModal, setProductSearchQuery, setAvailableProducts, fetchAvailableProducts, selectedShowProducts, removeProducts, setSelectedProducts, selectedProducts, handleSetMainProduct, setSelectedShowProducts, isLoading }) {
  const dispatch = useDispatch()
  const [productlist, setProductList] = useState([])
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredProducts, setFilteredProducts] = useState([]);
  // const [selectedProducts, setSelectedProducts] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [groupNo, setGroupNo] = useState(productToEdit?.group_no || null)
  const [groupName, setGroupName] = useState(productToEdit?.name || null)
  const [searchShowProduct, setSearchShowProduct] = useState('')
  const [filterShowProduct, setFilterShowProduct] = useState([])
  const [mainProductGroup, setMainProductGroup] = useState(false)
  const dropdownRef = useRef(null);

  useEffect(() => {
    // getProdcutData()
    const initialize = async () => {
      if (type === 'edit') {
        // const mainProductId = selectedShowProducts.find(p => p.is_main_product === 1)?.id || null;
        // if (mainProductId !== null) {
        //   await new Promise(resolve => setTimeout(resolve, 0));
        // }
        setMainProductGroup(true);
        handlegetProductData();
      } else if (type === 'add') {
        getNextGroupNumber();
      }
    };

    initialize();

  }, [])

  // Function to get the next available group number
  const getNextGroupNumber = async () => {
    try {
      const response = await getApi('/product-group?per_page=1&sort_by=group_no&sort_order=desc');
      if (response?.success && response.data.productGroups?.data?.length > 0) {
        const lastGroupNo = parseInt(response.data.productGroups.data[0].group_no) || 0;
        setGroupNo(lastGroupNo + 1);
      } else {
        setGroupNo(1); // Start with 1 if no existing group numbers
      }
    } catch (error) {
      console.error("Error fetching next group number:", error);
      setGroupNo(1); // Fallback to 1 if there's an error
    }
  }

  const handlegetProductData = async () => {
    const response = await getApi(`/product-group/${productToEdit?.group_id}`)
    if (response?.success) {
      setSelectedShowProducts(response?.data?.productGroup?.products)
    }

  }
  const getProdcutData = async () => {
    const response = await getApi('/product?per_page=50')
    if (response?.success) {
      setProductList(response.data.products?.data || []);
    }
  }

  useEffect(() => {
    if (searchShowProduct.trim() === '') {
      setFilterShowProduct([]);
      return;
    }
    // const filtered = selectedShowProducts.filter(product => {
    //   if (!product?.name_en) return false;
    //   // const searchWords = searchShowProduct.toLowerCase().trim();
    //   const searchWords = searchShowProduct.toLowerCase().split(/\s+/).filter(Boolean);
    //   const productWords = product.name_en.toLowerCase().split(/\s+/);
    //   return searchWords.every(searchWord =>
    //     productWords.some(productWord =>
    //       productWord.includes(searchWord)
    //     )
    //   );
    // });


    const filtered = selectedShowProducts.filter(product => {
      if (!product?.code && !product?.name_en && !product?.name_tc) return false;

      const searchShowProductLower = searchShowProduct.toLowerCase().trim();
      if (!searchShowProductLower) return true;

      const searchableFields = [
        product.code?.toString().toLowerCase() || '',
        product.name_en?.toLowerCase() || '',
        product.name_tc?.toLowerCase() || ''
      ];

      const searchWords = searchShowProductLower.split(/\s+/).filter(Boolean);
      const codeMatches = product.code?.toString().toLowerCase() === searchShowProductLower;
      const nameMatches = searchWords.every(searchWord =>
        searchableFields.some(field =>
          field.includes(searchWord)
        )
      );

      return codeMatches || nameMatches;
    });
    setFilterShowProduct(filtered);
  }, [searchShowProduct]);

  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredProducts([]);
      setIsDropdownOpen(false);
      return;
    }
    const filtered = productlist.filter(product => {
      if (!product?.name_en) return false;
      const searchWords = searchTerm.toLowerCase().split(/\s+/).filter(Boolean);
      const productWords = product.name_en.toLowerCase().split(/\s+/);
      return searchWords.every(searchWord =>
        productWords.some(productWord =>
          productWord.includes(searchWord)
        )
      );
    });
    setFilteredProducts(filtered);
    setIsDropdownOpen(filtered.length > 0);
  }, [searchTerm]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleProductClick = (product) => {
    setSelectedProducts(prev => {
      const isAlreadySelected = prev.some(p => p.id === product.id);
      if (isAlreadySelected) {
        return prev.filter(p => p.id !== product.id);
      } else {
        return [...prev, product];
      }
    });
    setSearchTerm('');
    setIsDropdownOpen(false);
  };

  const handleRemoveItem = (idToRemove) => {
    setSelectedProducts(prevItems => prevItems.filter(item => item.id !== idToRemove));
  };

  const UpdateProductGroup = async () => {
    let isMainProductSet = false;
    selectedShowProducts.forEach((x) => {
      if (x.is_main_product === 1) {
        isMainProductSet = true;
        return;
      }
    });
    let formDatas;
    type === 'edit' ?
      formDatas = new URLSearchParams()
      :
      formDatas = new FormData()

    formDatas.append('group_no', groupNo)
    formDatas.append('name', groupName)
    if (Array.isArray(selectedShowProducts)) {
      selectedShowProducts.forEach((x, ind) => {
        if (x) {
          formDatas.append(`products[${ind}][id]`, x?.id);
          formDatas.append(`products[${ind}][is_main_product]`, x?.is_main_product);
        }
      });
    }
    try {
      if (groupNo && groupName) {
        setIsLoading(true);
        let response;
        if (isMainProductSet) {
          // if(mainProductGroup){

            type === 'edit' ?
            response = await putApi(`/product-group/${productToEdit?.group_id}`, formDatas.toString(),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                },
              }
            )
            :
            response = await postApi(`/product-group`, formDatas)


          if (response?.success) {
            toast.success(response.msg || `Product group updated successfully`);
            await fetchData();
            setMethodType('');
            setSelectedProducts([])
          } else {
            toast.error(response?.msg || `Failed to update product group`);
          }
          dispatch(clearIdsStatus())
        } else {
          toast.error("Please select a main product group")
        }
      } else {
        toast.error('Please fill the group number and group name')
      }
    } catch (error) {
      const errorMsg = error.response?.data?.msg || error.message || `Failed to update product group`;
      toast.error(errorMsg);
    } finally {
      setIsLoading(false);
    }
  }


  return (
    <div class="row">

      <div class="col-sm-12">
        <div class="setting-right position-relative  add-new-product-group only-products">
          <h3>Add New Product Group</h3>
          <div class="button-settings">
            <div class="col-sm-12">
              <div class="d-flex justify-content-end gap-3">
                <button class="reset" onClick={() => { resetFormData(setFormData, setError, productToEdit, formDataCopy); handlegetProductData() }}>Reset</button>
                <button class="save" onClick={() => UpdateProductGroup()} disabled={isLoading}>
                  {isLoading ? 'Save' : 'Save'}
                </button>
              </div>
            </div>
          </div>
          <img
            src={window.getPublicUrl("/assets/images/close.svg")}
            alt="Close" className="close" onClick={() => {
              dispatch(clearIdsStatus());
              setMethodType('');
              resetFormData(setFormData, setError, productToEdit, formDataCopy);
            }}
          />

          <div className=" table-border-show product-grouping  add-arrival">
            <div className="table-header">
              {/* <div className="search-card">
                    <img src={window.getPublicUrl("/assets/images/search-icon.svg")}alt="" />
                   <input
                        type="text"
                        className="search-input"
                        placeholder="Search Product"
                        value={searchShowProduct}
          onChange={(e) => setSearchShowProduct(e.target.value)}
          onFocus={() => searchShowProduct.trim() !== '' && setIsDropdownOpen(true)}
                      />
                      {isDropdownOpen && filteredProducts.length > 0 && (
          <div className="search-dropdown">
            {filteredProducts.map(product => (
              <div
                key={product.id}
                className={`dropdown-item ${
                  selectedProducts.some(p => p.id === product.id) ? 'selected' : ''
                }`}
                onClick={() => handleProductClick(product)}
              >
                {product.name_en}
                {selectedProducts.some(p => p.id === product.id) && (
                  <span className="selected-check float-end" >   <img src={window.getPublicUrl("/assets/images/check-mark.svg")}alt="" /></span>
                )}
              </div>
            ))}
          </div>
        )}
                  </div> */}
              {/* <a
                    href=""
                    className="add-product  d-flex align-items-center"
                  > */}
              {/* <div className='produts-group add-produt'
                   onClick={() => {
                     setSelectedProducts(selectedShowProducts)
                    setShowAddProductModal(true);
                    setProductSearchQuery('');
                    // setAvailableProducts([]);
                    // setSelectedProducts([]);
                    fetchAvailableProducts();
                  }}>
                    Add Products
                  </div> */}
              <button
                className="add-product d-flex align-items-center"
                onClick={() => {
                  setShowAddProductModal(true);
                  setProductSearchQuery('');
                  setAvailableProducts([]);
                  setSelectedProducts([]);
                  // fetchAvailableProducts();
                  setSelectedProducts(selectedShowProducts)
                }}
              >
                Add Product
              </button>

            </div>
            <div class="row">
              <div class="col-sm-3 mx-3">
                <div class="form-group">
                  <label for="productCode">Enter Group No.</label>
                  <input
                    type="number"
                    id=""
                    class="form-control"
                    placeholder="Enter group no."
                    value={groupNo}
                    onChange={(e) => setGroupNo(e?.target?.value)}
                    disabled={type === 'add' || type === 'edit'}
                  />
                </div>
              </div>
              <div class="col-sm-3 mx-3">
                <div class="form-group">
                  <label for="productCode">Enter Group Name.</label>
                  <input
                    type="text"
                    id=""
                    class="form-control"
                    placeholder="Enter group name."
                    value={groupName}
                    onChange={(e) => setGroupName(e?.target?.value)}
                    // disabled={type === 'add' || type === 'edit'}
                  />
                </div>
              </div>
            </div>
            <div className="permission-table-inner">

              <div class="table-outer">
                {((filterShowProduct || selectedShowProducts) && searchShowProduct !== '' ? filterShowProduct : selectedShowProducts).map((x, index) => {
                  return (
                    <div class="table-inner" key={index}>
                      <ul>
                        <li className='sr-no'>
                          <label class="session-check-radio">
                            <input type="radio" name="session-type" checked={x.is_main_product === 1} onChange={() => { setMainProductGroup(true); handleSetMainProduct(x) }} />
                            <span class="checkmark-radio"></span>
                          </label>
                        </li>
                        <li className='code'>{x?.code}</li>
                        <li className='name'>{x?.name_en}</li>
                        <li className='name-tc'>{x?.name_tc}</li>
                        <li className='weight'>{x?.net_weight}</li>
                        <li className='specification'>{x?.specification}</li>
                      </ul>
                      <div class="">
                        {" "}
                        <span onClick={() => removeProducts(x.id)} class="cross-btn">
                          <img
                            src={window.getPublicUrl(
                              "/assets/images/white-cross.png"
                            )}
                            alt=""
                          />
                        </span>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>

          {/* <div class="button-settings">
              <div class="col-sm-12">
                <div class="d-flex justify-content-end gap-3">
                  <button class="reset" onClick={()=>{resetFormData(setFormData, setError,productToEdit,formDataCopy);handlegetProductData()}}>Reset</button>
                  <button class="save" onClick={() => UpdateProductGroup()} disabled={isLoading}>
                    {isLoading ?'Save...':'Save'}
                  </button>
                </div>
              </div>
            </div> */}
        </div>
      </div>
      {/* } */}

    </div>
  )
}

export default EditProductGroup